import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastComponent } from '../../shared/toast/toast.component';
import { OrganizationService } from '../../services/organization.service';
import { AuthService } from '../../services/auth.service';
import { RecordService } from '../../services/record.service';
import { Organization } from '../../shared/models/organization.model';
import { Record } from '../../shared/models/record.model';
import { ee, perPage50 } from '../../shared/constants';
import { removeTooltipElement, formatNotes } from '../../shared/functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-organization-details',
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.scss'],
  standalone: false
})
export class OrganizationDetailsComponent implements OnInit, OnDestroy {
  auth = inject(AuthService);
  private organizationService = inject(OrganizationService);
  private recordService = inject(RecordService);
  toast = inject(ToastComponent);
  private router = inject(Router);
  private route = inject(ActivatedRoute);


  isLoading = {
    organization: true,
    records: true,
    stats: true
  };
  isEditOrganizationDetailsModalVisible = false;
  field = '';
  perPage = perPage50;
  formatNotes = formatNotes;
  // Organization
  id = '';
  organization: Organization;
  // Arrays
  organizations: Organization[] = [];
  records: Record[] = [];
  count = 0;
  page = 0;
  currentContent = 'track-record';
  menuItems = [
    { name: 'Info & Records', link: 'track-record', icon: 'list' },
  ];

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    ee.on('changeContent', (data: string) => this.currentContent = data);
    ee.on('getRecords', (page?: number) => this.getRecords(this.id, page));
    ee.on('getOrganization', () => this.getOrganization(this.id));
    this.getOrganization(this.id);
    this.getOrganizations();
    this.getRecords(this.id);
    // this.getStats(this.id);
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
    ee.off('getRecords', () => {});
    ee.off('getOrganization', () => {});
    removeTooltipElement();
  }

  getOrganization(id: string): void {
    this.isLoading.organization = true;
    this.organizationService.get(id)
      .pipe(finalize(() => this.isLoading.organization = false ))
      .subscribe({
        next: res => this.organization = res,
        error: err => {
          this.router.navigate(['/organizations']);
          this.toast.setMessage(err.error.message, 'danger');
        },
      });
  }

  getOrganizations(): void {
    this.organizationService.search({})
      .subscribe({
        next: res => this.organizations = res.results,
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  getRecords(id: string, page?: number): void {
    this.isLoading.records = true;
    this.page = page || 0;
    this.recordService.search({
      _organizations: id,
      page: this.page,
      perPage: this.perPage,
    })
      .pipe(finalize(() => this.isLoading.records = false))
      .subscribe({
        next: res => {
          this.records = res.results;
          this.count = res.count;
        },
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  toggleEditOrganizationDetailsModal(field: string): void {
    this.isEditOrganizationDetailsModalVisible = true;
    this.field = field;
    ee.emit('showEditOrganizationDetailsModal', field);
  }

}
